import { useActionsColumn } from '../../../features/table/helpers/useActionsColumn';
import { ProductCategoriesActionsBodyCell } from '../components/ProductCategoriesActionsBodyCell';

export const useProductCategoriesActionColumn = () => {
  return useActionsColumn({
    render: (text: string, row: any) => <ProductCategoriesActionsBodyCell row={row} />,
  });
};
